import axios from './http'

//退出接口
export const logout = params => {
    return axios.post('/user/logout', params)
};

//统计数据
export const analysisData = params => {
    return axios.get('/data/index', {params: params})
};

//交易明细
export const tradeDetail = params => {
    return axios.get('data/trade-detail', {params: params});
};

//查看笔记
export const apiGetNotes = params => {
    return axios.get('/notes/index', {params: params});
};

//创建笔记
export const apiSaveNotes = params => {
    return axios.post('/notes/save', params);
};

// 账户排序
export const apiAccountSort = params => {
    return axios.post('/accounts/sort', params);
};

// 原始数据-持仓汇总
export const apiTakeTotal = params => {
    return axios.get('/original/take-total', {params: params});
};

export const apiChangePassword = params => {
    return axios.put('/user/changePassword', params);
}